import type { UpdateLabWorkbookRequest } from '@resistapp/common/api-types';

export type PrimerPrepFormValues = {
  prescreening: boolean;
  oneHealthOverride: boolean;
  numChips: number;
  defaultMmLot: string;
  primerStorageFindLocation: string;
  primerStorageLeaveLocation: string;
};

export type PrimerPrepComparableValues = {
  numChips: number;
  oneHealthOverride?: boolean;
  primerStorageFindLocation?: string;
  primerStorageLeaveLocation?: string;
};

function normalizeText(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function normalizeNumChips(value: unknown): number {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 1) {
    return 1;
  }
  return Math.round(value);
}

type ToComparableOptions = {
  isPrimerPrepReadOnly: boolean;
};

export function toPrimerPrepComparableValues(
  values: Partial<PrimerPrepFormValues> | null | undefined,
  options: ToComparableOptions,
): PrimerPrepComparableValues | null {
  if (!values) {
    return null;
  }
  const numChips = normalizeNumChips(values.numChips);
  const base: PrimerPrepComparableValues = { numChips };
  if (options.isPrimerPrepReadOnly) {
    return base;
  }
  return {
    ...base,
    oneHealthOverride: Boolean(values.oneHealthOverride),
    primerStorageFindLocation: typeof values.primerStorageFindLocation === 'string' ? values.primerStorageFindLocation : '',
    primerStorageLeaveLocation:
      typeof values.primerStorageLeaveLocation === 'string' ? values.primerStorageLeaveLocation : '',
  };
}

type BuildPayloadOptions = {
  isPrimerPrepReadOnly: boolean;
};

export function buildPrimerPrepUpdatePayload(
  values: Partial<PrimerPrepFormValues>,
  options: BuildPayloadOptions,
): UpdateLabWorkbookRequest {
  const numChips = normalizeNumChips(values.numChips);
  if (options.isPrimerPrepReadOnly) {
    return { numChips };
  }
  return {
    numChips,
    oneHealthOverride: Boolean(values.oneHealthOverride),
    primerStorageFindLocation: normalizeText(values.primerStorageFindLocation),
    primerStorageLeaveLocation: normalizeText(values.primerStorageLeaveLocation),
  };
}

